import { FunctionComponent } from "react";
import TimelineWrapper from "./TimelineWrapper";
import Graduate from "../../assets/pictures/Icons/graduate";
import Hospital from "../../assets/pictures/Icons/hospital";
import OpenBook from "../../assets/pictures/Icons/openBook";
import Scalpel from "../../assets/pictures/Icons/scalpel";

interface MyTimelineProps {}

const MyTimeline: FunctionComponent<MyTimelineProps> = () => {
  return (
    <div className="timeline-section">
      <div className="title">
        <h2>Moja historia</h2>
      </div>
      <TimelineWrapper
        alternative
        items={[
          {
            label: "1989",
            children:
              "Absolwent Wydziału Lekarskiego Akademii Medycznej (obecnie Uniwersytet Medyczny) im. Karola Marcinkowskiego w Poznaniu.",
            icon: Graduate,
          },
          {
            label: "1989-2017",
            children:
              "Praca w Specjalistycznym ZOZ nad Matką i Dzieckiem, przy ul. Krysiewicza 7 na Oddziale Chirurgii Dziecięcej i Leczenia Oparzeń.",
            icon: Hospital,
          },
          {
            label: "Lata 1990s",
            children:
              "Ukończenie specjalizacji w zakresie chirurgii dziecięcej pod nadzorem dr.med. Zdzisława Krzyżańskiego.",
            icon: OpenBook,
          },
          {
            label: "2005",
            children:
              "Utworzenie Poradni Chirurgii Dziecięcej w Poznańskim Ośrodku Specjalistycznych Usług Medycznych 'POSUM' wspólnie z dr.med. Jackiem Grażyńskim.",
            icon: Scalpel,
          },
          {
            label: "2017",
            children:
              "Rozpoczęcie pracy w na Oddziale Chirurgii Dziecięcej SP ZOZ w Gostyniu.",
            icon: Hospital,
          },
          {
            label: "2018",
            children:
              "Rozpoczęcie pracy w nowoczesnym Centrum Medycznym Ostoja w Gostyniu.",
            icon: Hospital,
          },
          {
            label: "2019 - 2024",
            children: "Współpraca z Kliniką Ty i Dziecko w Suchym Lesie.",
            icon: Hospital,
          },
          {
            label: "2021 - 2026",
            children:
              "Praca w nowej, dobrze wyposażonej placówce - Centrum Medycznym Kawiary w Gnieźnie.",
            icon: Hospital,
          },
        ]}
      />
    </div>
  );
};

export default MyTimeline;
